"use strict";
/****
 * 前端个股单页头部通用组件
 *
 *  */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var webconfig = require('../../../config/web.js');
var fieldtools_1 = __importDefault(require("../commonutil/fieldtools"));
var code = stockInfo.code;
var hqcode = stockInfo.hqCode;
gettopqute();
getstockdatastate();
setInterval(gettopqute, 30000);
//获取当前个股数据状态信息,主要用于处理状态变化:  数据四期接口  周康
function getstockdatastate() {
    $.ajax({
        url: webconfig.getWebPath('datacenter') + 'api/data/v1/get',
        type: 'GET',
        dataType: 'jsonp',
        data: {
            reportName: 'RPT_STOCK_HEADERCHANGE',
            columns: 'ALL',
            filter: "(SECURITY_CODE=\"" + code + "\")",
            pageNumber: 1,
            pageSize: 10,
            source: "WEB",
            client: "WEB"
        }
    }).then(function (json) {
        var _a;
        var list = (_a = json === null || json === void 0 ? void 0 : json.result) === null || _a === void 0 ? void 0 : _a.data;
        if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
            var $box = $(".sinstock-filter-wrap");
            var html = '';
            var i = 0;
            var item = list[0];
            item.BILLBOARD_CODE == 1 ? i = i + 1 : $('td[data-page="gglhb"]', $box).remove(); //龙虎榜单
            item.BLOCKTRADE_CODE == 1 ? i = i + 1 : $('td[data-page="dzjy"]', $box).remove(); //大宗交易
            item.MARGIN_CODE == 1 ? i = i + 1 : $('td[data-page="rzrq"]', $box).remove(); //融资融券
            item.MUTUAL_CODE == 1 ? i = i + 1 : $('td[data-page="hsgtcg"]', $box).remove(); //沪深港通
            var hyLink = "/report/industry.jshtml?hyid=" + item.INDUSTRY_CODE + "&hyname=" + item.INDUSTRY_NAME;
            var htmls = ['<td data-page="gdzjc"><a href="//data.eastmoney.com/executive/gdzjc/' + code + '.html">股东增减持</a></td>',
                '<td data-page="hyyb"><a href="' + hyLink + '">行业研报</a></td>',
                '<td data-page="wdm"><a href="//guba.eastmoney.com/qa/qa_search.aspx?company=' + code + '&keyword=&questioner=&qatype=1">问董秘</a></td>',
                '<td data-page="zx"><a href="//so.eastmoney.com/web/s?keyword=' + code + '">资讯</a></td>'];
            html = htmls.slice(0, 4 - i).join(' ');
            $("tr", $box).eq(1).append(html);
            //是否显示new标识
            var new_img = '<span class="icon icon_new valign-ttop" alt="新"></span>';
            item.BILLBOARD_CODE_NEW == 1 ? $('td[data-page="gglhb"] a', $box).append(new_img) : ""; //龙虎榜单
            item.BLOCKTRADE_CODE_NEW == 1 ? $('td[data-page="dzjy"] a', $box).append(new_img) : ""; //大宗交易
            item.NOTICE_CODE == 1 ? $('td[data-page="notices"] a', $box).append(new_img) : ""; //公告大全
            item.HOLDER_SUM_CODE == 1 ? $('td[data-page="gdhs"] a', $box).append(new_img) : ""; //股东户数
            item.ORG_SURVEY_CODE == 1 ? $('td[data-page="jgdy"] a', $box).append(new_img) : ""; //机构调研
            item.GM_CODE == 1 ? $('td[data-page="gddh"] a', $box).append(new_img) : ""; //股东大会
            item.EXEUTIVE_STOCK_CODE == 1 ? $('td[data-page="ggcg"] a', $box).append(new_img) : ""; //高管持股
            item.SALE_LIFT_CODE == 1 ? $('td[data-page="xsjj"] a', $box).append(new_img) : ""; //限售解禁
            item.STOCK_RESERCH_CODE == 1 ? $('td[data-page="ggyb"] a', $box).append(new_img) : ""; //个股研报
            item.CAPSTOCK_STRUCTURE_CODE == 1 ? $('td[data-page="gbjg"] a', $box).append(new_img) : ""; //股本结构
            item.HOLDER_CHANGE_CODE == 1 ? $('td[data-page="gdzjc"] a', $box).append(new_img) : ""; //股东增减持、
        }
    });
}
//获取行情信息 ：行情接口 马文豹
function gettopqute() {
    $.ajax({
        url: webconfig.getWebPath('quoteurl') + 'api/qt/stock/get',
        type: 'GET',
        dataType: 'jsonp',
        jsonp: 'cb',
        data: {
            fltt: "2",
            invt: "2",
            secid: hqcode,
            fields: "f57,f58,f43,f47,f48,f168,f169,f170,f152",
            ut: "b2884a393a59ad64002292a3e90d46a5"
        },
    }).then(function (json) {
        if (json && json.data) {
            var data = json.data;
            $("#newPrice").html(fieldtools_1["default"].fieldfmt(data.f43, { showcolor: true, colorvalue: data.f169, num: data.f152 })); //最新价
            $("#zd").html(fieldtools_1["default"].fieldfmt(data.f169, { showcolor: true, num: data.f152 })); //涨跌
            $("#zdf").html(fieldtools_1["default"].fieldfmt(data.f170, { showcolor: true, num: data.f152, fix: "%" })); //涨跌幅
            $("#hs").html(fieldtools_1["default"].fieldfmt(data.f168, { fix: "%", num: 2 })); //换手率
            $("#sum").html(fieldtools_1["default"].fieldfmt(data.f47, { fix: "手", num: 2 })); //总手
            $("#totalPrice").html(fieldtools_1["default"].fieldfmt(data.f48, { num: 2 })); //金额
        }
    });
}
